import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSanityContent } from '@hooksV2/useSanityContent';
import { getImageKitImageUrlForSanity } from '@/content/contentHelpers';
import placeholderImage from '@/assets/images/placeholder.png';

const VendorsGrid = ({ dashboardLinkPrefix }) => {
  const [arrayToShow, setArrayToShow] = useState([]);
  const sanityData = useSanityContent();

  useEffect(() => {
    const shuffledLoyaltyCompanies = sanityData.LoyaltyCompanies.sort(
      () => Math.random() - 0.5
    );
    setArrayToShow(shuffledLoyaltyCompanies.slice(0, 6));
  }, [sanityData]);

  return (
    <div className="flex flex-col gap-[14px]">
      <div className="flex justify-between w-full">
        <h4 className="text-[18px] md:text-xl font-medium text-foreground">
          Aktuelt fra våre partnere
        </h4>
        <Link
          className="border-b md:border-none border-b-[#333] h-[24px] leading-[27px] md:hover:underline"
          to={`${dashboardLinkPrefix}/vendors`}
        >
          Se alle
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-[27px]">
        {arrayToShow.map((el) => (
          <Link
            key={el.companyCode?.current}
            className="flex flex-col gap-2"
            to={`${dashboardLinkPrefix}/vendors/company/${el.companyCode?.current}`}
          >
            <img
              alt={el?.title || 'Vendor'}
              className="w-full h-[135px] rounded-[8px] object-cover"
              src={
                getImageKitImageUrlForSanity(el?.coverPhoto?.asset, 400) ||
                placeholderImage
              }
            />
            <p className="text-sm md:text-base text-black w-full">{el.title}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default VendorsGrid;
